import { connectedStore } from '../../store';
import getActivePageId from '../selectors/active-page-id';
import getPage from '../selectors/page';

const getActivePage = () => {
  const store = connectedStore.get();
  const state = store.getState();
  const activePageId = getActivePageId(state);
  return getPage(state, activePageId);
};

export default getActivePage;
